import React, { useState, useRef } from 'react';
import { Container, Box } from '@mui/material';
import Canvas from './Canvas';
import LayerList from './LayerList';
import LayerSettings from './LayerSettings';
import GlobalSettings from './GlobalSettings';
import Toolbar from './Toolbar';

const StampEditor = () => {
  const [layers, setLayers] = useState([]);
  const [selectedLayerId, setSelectedLayerId] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');

  const canvasRef = useRef(null);

  const handleAddLayer = (type) => {
    const newLayer = {
      id: Date.now(),
      type: type,
      x: 100,
      y: 100,
      width: 100,
      height: 100,
      opacity: 1,
        text: 'Sample Text',
        fontFamily: 'Arial',
        fontSize: 24,
        color: '#000000',
        style: 'normal',
        borderColor: '#000000',
        borderWidth: 2,
        shadowColor: '#000000',
        shadowBlur: 5,
        shadowOffsetX: 2,
        shadowOffsetY: 2,
      src: null,
      fontStyle: 'normal'
    };
    setLayers([...layers, newLayer]);
  };

  const handleSelectLayer = (id) => {
    setSelectedLayerId(id);
  };

  const handleMoveLayer = (id, direction) => {
    const index = layers.findIndex(layer => layer.id === id);
    if(index === -1) return;
    const newLayers = [...layers];
    if (direction === 'up' && index > 0) {
        [newLayers[index], newLayers[index - 1]] = [newLayers[index - 1], newLayers[index]];
    } else if (direction === 'down' && index < layers.length - 1) {
        [newLayers[index], newLayers[index + 1]] = [newLayers[index + 1], newLayers[index]];
    }
    setLayers(newLayers);
  };

  const handleRemoveLayer = (id) => {
    setLayers(layers.filter(layer => layer.id !== id));
      if(selectedLayerId === id) {
          setSelectedLayerId(null);
      }
  };

  const handleDuplicateLayer = (id) => {
      const originalLayer = layers.find(layer => layer.id === id);
      if(!originalLayer) return;
      const newLayer = { ...originalLayer, id: Date.now(), x: originalLayer.x + 20, y: originalLayer.y + 20 };
      setLayers([...layers, newLayer]);
  };

  const handleUpdateLayer = (id, update) => {
    setLayers(layers.map(layer => (layer.id === id ? { ...layer, ...update } : layer)));
  };

    const handleUpdateGlobalSetting = (update) => {
      // 全体設定更新処理
       setBackgroundColor(update.backgroundColor);
  };

    const handleSaveCanvas = () => {
        const canvas = canvasRef.current;
        const dataUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'stamp.png';
        link.click();
    };

  return (
    <Container maxWidth="lg">
      <Toolbar onAddLayer={handleAddLayer} onSaveCanvas={handleSaveCanvas}/>
      <Box display="flex">
        <LayerList
          layers={layers}
          selectedLayerId={selectedLayerId}
          onSelectLayer={handleSelectLayer}
          onMoveLayer={handleMoveLayer}
          onRemoveLayer={handleRemoveLayer}
          onDuplicateLayer={handleDuplicateLayer}
        />
        <Box flexGrow={1}>
          <Canvas
              layers={layers}
              selectedLayerId={selectedLayerId}
              canvasRef={canvasRef}
              backgroundColor={backgroundColor}
              onUpdateLayer={handleUpdateLayer}
           />
         <GlobalSettings  onUpdateGlobalSetting={handleUpdateGlobalSetting}/>
        </Box>
        <LayerSettings
          selectedLayerId={selectedLayerId}
          layers={layers}
          onUpdateLayer={handleUpdateLayer}
        />
      </Box>
    </Container>
  );
};

export default StampEditor;